/** @module csi/heading/FileSizeRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/Number",
	"csi/utility/fileUtility"
], function(declare, Number, {formatFileSize}) {

	return declare(Number, {
		/**
		 * Convert file size value to human readable format
		 *  @param {Any} value
		 */
		formatValue(value) {
			return formatFileSize(value);
		}
	});
});